/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgBus48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M42.065 33.493v4.61H5.941v-4.61h15.42l2.605 4.61 2.855-4.61h15.244zM27.22 26.651h-6.756c.233 1.368.739 2.305 3.503 2.792 2.647 0 2.647-1.456 3.253-2.792zM39.59 10.64H8.417L6.93 14.598c11.016-2.114 22.227-2.169 33.65 0 0 0-1.217-3.949-.99-3.959z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M41.777 19.052v18.65'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M41.78 19.052c-7.67 3.183-13.188 10.414-17.604 19.144'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M37.995 28.278a1.064 1.064 0 100-2.128 1.064 1.064 0 000 2.128z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M23.965 22.721a3.436 3.436 0 013.434 3.434 3.436 3.436 0 01-3.434 3.435'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M46.727 13.724c0-.611-.495-1.106-1.106-1.106h-.758c-.61 0-1.105.495-1.105 1.106v2.242c0 .61.495 1.106 1.105 1.106h.758c.611 0 1.106-.495 1.106-1.106v-2.242 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M35.344 41.319h5.443v3.516c0 .791-.641 1.432-1.432 1.432h-2.578a1.433 1.433 0 01-1.433-1.432v-3.516z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M6.152 19.052l1.936-6.093a8.183 8.183 0 017.799-5.707h16.16a8.183 8.183 0 017.799 5.707l1.935 6.093'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M4.864 41.32h38.204c.382 0 .692-.31.692-.692v-1.74a.69.69 0 00-.692-.692H4.864a.692.692 0 00-.692.692v1.74c0 .382.31.691.692.691v0z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M44.957 17.073a1.98 1.98 0 01-1.98 1.98h-1.2M36.832 35.568a2.227 2.227 0 100-4.453 2.227 2.227 0 000 4.453z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M23.965 10.793v7.763'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M41.781 18.958l-35.629.093v18.65'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M6.152 19.052c7.669 3.183 13.188 10.414 17.604 19.144'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M9.935 28.278a1.064 1.064 0 100-2.128 1.064 1.064 0 000 2.128z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M23.965 22.721a3.436 3.436 0 00-3.434 3.434 3.436 3.436 0 003.434 3.435'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M1.201 13.724c0-.611.495-1.106 1.106-1.106h.758c.61 0 1.105.495 1.105 1.106v2.242c0 .61-.495 1.106-1.105 1.106h-.758c-.611 0-1.106-.495-1.106-1.106v-2.242 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M12.58 41.319H7.137v3.516c0 .791.641 1.432 1.433 1.432h2.577c.792 0 1.433-.641 1.433-1.432v-3.516z'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M38.597 10.545H8.982'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M2.97 17.073a1.98 1.98 0 001.98 1.98h1.2M11.098 35.568a2.227 2.227 0 100-4.453 2.227 2.227 0 000 4.453z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M23.965 10.793v7.763'
      />
    </svg>
  );
}

export default SvgBus48;
